'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _bookingCompanies = require('utils/bookingCompanies');

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassengerListTable = function PassengerListTable(_ref) {
    var headerText = _ref.headerText,
        introText = _ref.introText,
        reminderText = _ref.reminderText,
        bookingCompany = _ref.bookingCompany,
        props = (0, _objectWithoutProperties3.default)(_ref, ['headerText', 'introText', 'reminderText', 'bookingCompany']);

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components2.PassengerList, props),
        _react2.default.createElement(_components2.Legal, null)
    );
};
// TODO: PropTypes

exports.default = (0, _pacomo.pacomoTransformer)(PassengerListTable);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/PassengerList/PassengerListTable.js
// module id = 1308
// module chunks = 0